import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/http/auth.service';
import { catchError, exhaustMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';

/**
 * This service intercepts every HTTP request and handles authentication.
 */
@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  private authService = inject(AuthService);
  private router = inject(Router);


  /**
   * Takes the latest user value to add a token to an intercepted request header. Redirects to login page if a user is not authenticated.
   * @param req an intercepted request.
   * @param next the next interceptor in the chain, or the backend.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.user.pipe(
      take(1),
      exhaustMap(user => {
        if (!user) {
          return next.handle(req);
        }
        const modifiedRequest = req.clone({ setHeaders: { Authorization: `Bearer ${user.jwtToken}` } });
        return next.handle(modifiedRequest).pipe(catchError(error => this.handleError(error)));
      })
    );
  }

  private handleError(errorResponse: HttpErrorResponse) {
    if (errorResponse.status === 401) {
      this.authService.logout();
      this.router.navigate(['/login']);
    }
    return throwError(errorResponse);
  }
}
